<template>
  <a-modal
    :visible="visible"
    :width="960"
    :confirm-loading="confirmLoading"
    :footer="null"
    @ok="handleOk"
    @cancel="handleCancel"
    centered
  >
    <template slot="title">
      <span style="font-size: 18px; font-weight: 800">处理日志</span>
      <a-button type="primary" size="small" style="margin-left: 12px; margin-top: -4px; top: -1px">
        {{ exceptionCode }}
      </a-button>
    </template>
    <a-timeline style="padding-top: 13px; max-height: 70vh; overflow-y: auto">
      <a-timeline-item v-for="(item, index) in dataSource" :key="index">
        <div style="display: flex">
          <div>
            <span style="font-weight: 600">处理时间：</span
            ><span style="color: #929292">{{ item.solveTime }}</span>
          </div>
          <div style="margin-left: 70px">
            <span style="font-weight: 600">状态变更：</span
            ><span style="color: #929292">{{ returnStute(item.preSolveStatus) }} →</span>
            <span style="color: #2396ff">{{ returnStute(item.nextSolveStatus) }}</span>
          </div>
          <div style="margin-left: 70px">
            <span style="font-weight: 600">处理人员：</span
            ><span style="color: #929292">{{ item.userDto.userName }}</span>
          </div>
        </div>
        <a-textarea
          v-model="item.remark"
          placeholder="请输入处理步骤和处理方法"
          disabled
          style="margin-top: 12px"
        />
      </a-timeline-item>
    </a-timeline>
    <!-- <a-form-model :layout="layout" :model="form" :rules="rules">
      <a-form-model-item label="状态变更为" prop="name">
        <a-select allowClear v-model="form.stutes" style="width: 100%">
          <a-select-option value="全部"> 全部</a-select-option>
          <a-select-option value="团队1"> 团队1</a-select-option>
          <a-select-option value="团队2"> 团队2</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="处理过程描述" prop="juese">
        <a-textarea :rows="12" v-model="form.juese" placeholder="请输入处理步骤和处理方法" />
      </a-form-model-item>
    </a-form-model> -->
  </a-modal>
</template>

<script>
import { logparseinfo } from '@/api/Monitor/abnormal'
export default {
  data() {
    return {
      exceptionCode: '',
      confirmLoading: false,
      visible: false,
      layout: 'horizontal',
      form: {
        juese: undefined,
        name: undefined,
        people: undefined
      },
      value: '查看了告警日志，修改了站点配置。',
      rules: {
        name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        juese: [{ required: true, message: '请输入角色类型', trigger: 'blur' }]
        // people: [{ required: true, message: '请选择用户组成员', trigger: 'blur' }]
      },
      dataSource: []
    }
  },
  methods: {
    showModel(record) {
      this.visible = true
      this.exceptionCode = record.exceptionCode
      this.form = {}
      this.form.id = record.id
      this.form.monitorId = record.monitorId
      this.dataSource = []
      logparseinfo({
        exceptionCode: record.exceptionCode,
        exceptionClass: record.exceptionClass
      }).then((res) => {
        // res.data = res.data.reverse()
        if (res.data) {
          this.dataSource = res.data.reverse()
        }
      })
    },
    dateData(property, type) {
      //property是你需要排序传入的时间,type为true时是升序，false为降序
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return Date.parse(value2) - Date.parse(value1)
      }
    },
    handleOk(e) {
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },
    handleCancel(e) {
      this.visible = false
    },
    returnStute(data) {
      switch (data) {
        case 0:
          return '已忽略'
        case 1:
          return '待处理'
        case 2:
          return '已处理'

        default:
          break
      }
    }
  }
}
</script>

<style></style>
